<div [formGroup]="formGroup">
  <tui-input-date
    tuiUnfinishedValidator="Finish filling the field"
    [formControlName]="formControlName"
    [max]="max"
    [min]="min"
    [nativeId]="id"
    [pseudoFocus]="focus ?? null"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [readOnly]="properties?.readOnly ?? false"
    [tuiHintContent]="hintContent"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldIconLeft]="icon"
    [tuiTextfieldPostfix]="postfix"
    [tuiTextfieldPrefix]="prefix"
    [tuiTextfieldSize]="size"
    (focusedChange)="handleFocusedChange($event)"
  >
    {{ label }}
    <span
      class="tui-required"
      *ngIf="validators.required"
    ></span>
    <input
      tuiTextfield
      [attr.placeholder]="placeholder ?? ''"
      [attr.required]="validators.required"
    />
  </tui-input-date>
</div>
